import { EnergyMode } from '../../types/user-insight'

export const energyModeHierarchy = [
  EnergyMode.PEAK,
  EnergyMode.ENERGIZED,
  EnergyMode.FUNCTIONAL,
  EnergyMode.STRUGGLING,
  EnergyMode.DRAINED,
]

// Energy mode breakpoints - these define the thresholds for each energy mode
export const ENERGY_MODE_BREAKPOINTS = {
  PEAK: 85,
  ENERGIZED: 65,
  FUNCTIONAL: 45,
  STRUGGLING: 25,
  DRAINED: 0,
} as const

export function getEnergyMode(energyScore: number): EnergyMode {
  if (energyScore >= ENERGY_MODE_BREAKPOINTS.PEAK) {
    return EnergyMode.PEAK
  }

  if (energyScore >= ENERGY_MODE_BREAKPOINTS.ENERGIZED) {
    return EnergyMode.ENERGIZED
  }

  if (energyScore >= ENERGY_MODE_BREAKPOINTS.FUNCTIONAL) {
    return EnergyMode.FUNCTIONAL
  }

  if (energyScore >= ENERGY_MODE_BREAKPOINTS.STRUGGLING) {
    return EnergyMode.STRUGGLING
  }

  return EnergyMode.DRAINED
}
